import { publicAPI, privateAPI } from "./api_helper";

import * as url from "./url_helper";

//Public API calls
//USER AUTHENTICATION
export const postLogin = (data) => publicAPI.post(url.POST_LOGIN, data);
export const postLogout = () => publicAPI.post(url.POST_LOGOUT);
export const postRegister = (data) => publicAPI.post(url.POST_REGISTER, data);
export const postRequestPasswordReset = (data) => publicAPI.post(url.POST_REQUEST_PASSWORD_RESET, data);
export const postValidateResetToken = (data) => publicAPI.post(url.POST_VALIDATE_RESET_TOKEN, data);
export const postResetPassword = (data) => publicAPI.post(url.POST_RESET_PASSWORD, data);

//Private API calls
//USER PASSWORD
export const postFirstLoginUpdateUserPassowrd = (data) => privateAPI.post(url.POST_FIRST_LOGIN_UPDATE_USER_PASSWORD, data)
export const postChangePassword = (data) => privateAPI.post(url.POST_CHANGE_PASSWORD, data)

//ADMIN USER MANAGEMENT
export const postActivateUser = (data) => privateAPI.post(url.POST_ACTIVATE_USER, data);
export const postUpdateUserPermissions = (data) => privateAPI.post(url.POST_UPDATE_USER_PERMISSIONS, data);
export const postUpdateUserRole = (data) => privateAPI.post(url.POST_UPDATE_USER_ROLE, data);
export const postDeleteUser = (data) => privateAPI.post(url.POST_DELETE_USER, data);
export const postCreateUser = (data) => privateAPI.post(url.POST_CREATE_USER, data);
export const postResendInvite = (data) => privateAPI.post(url.POST_RESEND_INVITE, data);
export const postCheckErpEmail = (data) => privateAPI.post(url.POST_CHECK_ERP_EMAIL, data);
export const postUpdateErpLink = (data) => privateAPI.post(url.POST_UPDATE_ERP_LINK, data);

//USER ADRESSES
export const postAddAddress = (data) => privateAPI.post(url.POST_ADD_USER_ADDRESS, data)
export const postGetUserAddresses = () => privateAPI.post(url.POST_GET_USER_ADDRESS)
export const postRemoveUserAddress = (data) => privateAPI.post(url.POST_REMOVE_USER_ADDRESS, data)

//ORDERS
export const postCreateOrder = (data) => privateAPI.post(url.POST_CREATE_ORDER, data)
export const postGetUserOrders = (data) => privateAPI.post(url.POST_GET_ORDERS, data);
export const postGetUserOrderDetails = (data) => privateAPI.post(url.POST_GET_ORDER_DETAILS, data);
export const postUpdateOrderItemNote = (data) => privateAPI.post(url.POST_UPDATE_ORDER_ITEM_NOTE, data);

//SAVED CARTS
export const postGetUserSavedCarts = (data) => privateAPI.post(url.POST_GET_USER_SAVED_CARTS, data);
export const postAddUserSavedCart = (data) => privateAPI.post(url.POST_ADD_USER_SAVED_CART, data);
export const postRemoveUserSavedCart = (data) => privateAPI.post(url.POST_DELETE_USER_SAVED_CART, data);

//ACTIVE CART
export const postGetUserCart = (data = {}) => privateAPI.post(url.POST_GET_USER_CART, data);
export const postValidateUserCart = () => privateAPI.post(url.POST_VALIDATE_USER_CART);
export const postAddCartItems = (data) => privateAPI.post(url.POST_ADD_CART_ITEMS, data);
export const postUpdateCartItem = (data) => privateAPI.post(url.POST_UPDATE_CART_ITEM, data);
export const postUpdateCartItemNotes = (data) => privateAPI.post(url.POST_UPDATE_CART_ITEM_NOTES, data);
export const postRemoveCartItem = (data) => privateAPI.post(url.POST_REMOVE_CART_ITEM, data);
export const postRemoveCartItems = (data) => privateAPI.post(url.POST_REMOVE_CART_ITEMS, data);
export const postClearCart = (data = {}) => privateAPI.post(url.POST_CLEAR_CART, data);
export const postSaveActiveCart = (data) => privateAPI.post(url.POST_SAVE_ACTIVE_CART, data);
export const postReplaceCartFromSaved = (data) => privateAPI.post(url.POST_REPLACE_CART_FROM_SAVED, data);
export const postReplaceCart = (data) => privateAPI.post(url.POST_REPLACE_CART, data);

//SUBACCOUNTS
export const postGetUserSubAccounts = (data) => privateAPI.post(url.POST_GET_USER_SUBACCOUNTS, data);
export const postAddUserSubAccount = (data) => privateAPI.post(url.POST_ADD_USER_SUBACCOUNT, data);
export const postUpdateUserSubAccount = (data) => privateAPI.post(url.POST_UPDATE_USER_SUBACCOUNT, data);
export const postDeleteUserSubAccount = (data) => privateAPI.post(url.POST_DELETE_USER_SUBACCOUNT, data);

//FAVORITES
export const postGetUserFavorites = (data) => privateAPI.post(url.POST_GET_USER_FAVORITES, data);
export const postAddUserFavorite = (data) => privateAPI.post(url.POST_ADD_USER_FAVORITE, data);
export const postDeleteUserFavorite = (data) => privateAPI.post(url.POST_DELETE_USER_FAVORITE, data);
export const postUpdateUserFavoriteName = (data) => privateAPI.post(url.POST_UPDATE_USER_FAVORITE_NAME, data);

//CUSTOMER CART (salesperson)
export const postGetSalespersonCustomers = (data) => privateAPI.post("/auth/salesperson-customers", data);

//SALES OFFERS
export const postGetSalesOfferClients = (data) => privateAPI.post(url.POST_GET_SALES_OFFER_CLIENTS, data);
export const postGetSalesOffers = (data = {}) => privateAPI.post(url.POST_GET_SALES_OFFERS, data);
export const postGetSalesOfferDetails = (data) => privateAPI.post(url.POST_GET_SALES_OFFER_DETAILS, data);
export const postCreateSalesOffer = (data) => privateAPI.post(url.POST_CREATE_SALES_OFFER, data);
export const postUpdateSalesOffer = (data) => privateAPI.post(url.POST_UPDATE_SALES_OFFER, data);
export const postPublishSalesOffer = (data) => privateAPI.post(url.POST_PUBLISH_SALES_OFFER, data);
export const postRenewSalesOffer = (data) => privateAPI.post(url.POST_RENEW_SALES_OFFER, data);
export const postCopySalesOfferToCart = (data) => privateAPI.post(url.POST_COPY_SALES_OFFER_TO_CART, data);

//INVOICES
export const postUserInvoices = (data) => privateAPI.post(url.POST_GET_USER_INVOICES, data);
export const postInvoicePdfs = () => privateAPI.post(url.POST_GET_INVOICE_PDFS);
export const getInvoicePdfDownload = (gr_id_inv) => privateAPI.get(`${url.GET_INVOICE_PDF_DOWNLOAD}/${gr_id_inv}`, { responseType: "blob" });

//DOWNLOAD CENTRE
export const getDownloadCentre = (packageId) => privateAPI.get(url.GET_DOWNLOAD_CENTRE, { params: packageId ? { package_id: packageId } : {} });
export const getDownloadFile = (fileId) => privateAPI.get(`${url.GET_DOWNLOAD_FILE}/${fileId}`, { responseType: "blob" });
export const getDownloadPackages = () => privateAPI.get(`${url.DOWNLOAD_ADMIN}/packages`);
export const getDownloadPackage = (packageId) => privateAPI.get(`${url.DOWNLOAD_ADMIN}/packages/${packageId}`);
export const postDownloadPackage = (data) => privateAPI.post(`${url.DOWNLOAD_ADMIN}/packages`, data);
export const putDownloadPackage = (packageId, data) => privateAPI.put(`${url.DOWNLOAD_ADMIN}/packages/${packageId}`, data);
export const deleteDownloadPackage = (packageId) => privateAPI.delete(`${url.DOWNLOAD_ADMIN}/packages/${packageId}`);
export const postDownloadSection = (packageId, data) => privateAPI.post(`${url.DOWNLOAD_ADMIN}/packages/${packageId}/sections`, data);
export const putDownloadSection = (sectionId, data) => privateAPI.put(`${url.DOWNLOAD_ADMIN}/sections/${sectionId}`, data);
export const deleteDownloadSection = (sectionId) => privateAPI.delete(`${url.DOWNLOAD_ADMIN}/sections/${sectionId}`);
export const postDownloadItem = (sectionId, data) => privateAPI.post(`${url.DOWNLOAD_ADMIN}/sections/${sectionId}/items`, data);
export const putDownloadItem = (itemId, data) => privateAPI.put(`${url.DOWNLOAD_ADMIN}/items/${itemId}`, data);
export const deleteDownloadItem = (itemId) => privateAPI.delete(`${url.DOWNLOAD_ADMIN}/items/${itemId}`);
export const postDownloadReorder = (data) => privateAPI.post(`${url.DOWNLOAD_ADMIN}/reorder`, data);
export const postDownloadImport = (packageId, data) => privateAPI.post(`${url.DOWNLOAD_ADMIN}/packages/${packageId}/import`, data);
export const postDownloadFiles = (packageId, formData, onUploadProgress) =>
  privateAPI.post(`${url.DOWNLOAD_ADMIN}/packages/${packageId}/files`, formData, { headers: { "Content-Type": "multipart/form-data" }, onUploadProgress });
export const deleteDownloadFile = (fileId) => privateAPI.delete(`${url.DOWNLOAD_ADMIN}/files/${fileId}`);
export const getDownloadUsers = () => privateAPI.get(`${url.DOWNLOAD_ADMIN}/users`);
export const putDownloadUserPackage = (userId, packageId) => privateAPI.put(`${url.DOWNLOAD_ADMIN}/users/${userId}`, { package_id: packageId });

//CONTACT FORM
export const postContactForm = (data) => privateAPI.post(url.POST_CONTACT_FORM, data);

//SHADOW API

export const postBlindModels = (model) => privateAPI.post(url.GET_BLIND_MODELS, model);
export const getShadowUserOrders = (data) => privateAPI.post(url.GET_SHADOW_ORDERS, data);
export const getShadowUserOrderDetails = (orderId, data) => privateAPI.post(url.GET_SHADOW_ORDER_DETAILS + "/" + orderId);
export const postBlindPrice = (data) => privateAPI.post(url.GET_BLIND_PRICE, data);
export const getFabricAvailability = () => privateAPI.post(url.GET_FABRIC_AVAILABILITY);
export const getProductRelations = () => privateAPI.post(url.GET_PRODUCT_RELATIONS);
export const getProductTypes = () => privateAPI.get(url.GET_PRODUCT_TYPES).then(r => r.data);
export const postNewBlindPrice = (data) => privateAPI.post(url.GET_NEW_BLIND_PRICE, data);
export const getNewProductRelations = () => privateAPI.get(url.GET_NEW_PRODUCT_RELATIONS).then(r => r.data);
export const getSyncConfiguratorCatalog = (lang) => privateAPI.get(url.GET_SYNC_CONFIGURATOR_CATALOG, { params: { lang } }).then((r) => r.data);
export const getSyncConfiguratorProduct = (productId, lang) => privateAPI.get(`${url.GET_SYNC_CONFIGURATOR_PRODUCT}/${productId}`, { params: { lang } }).then((r) => r.data);
export const postSyncConfiguratorPrice = (data) => privateAPI.post(url.POST_SYNC_CONFIGURATOR_PRICE, data).then((r) => r.data);

//SHADOW NEWS
export const getShadowNews = (data) => privateAPI.post(url.GET_SHADOW_NEWS, data);

//PRODUCTION TERMS
export const getProductionTerms = () => privateAPI.get(url.GET_PRODUCTION_TERMS);
export const getProductionTermGroupIndeksy = (groupId, lang) => privateAPI.get(`${url.GET_PRODUCTION_TERM_GROUPS}/${groupId}/indeksy`, { params: { lang } }).then((r) => r.data);
export const postEstimateProductionTerm = (data) => privateAPI.post(url.POST_ESTIMATE_PRODUCTION_TERM, data);

//ADMIN TOOLS (narzedzie synchronizacji)
export const getToolsList = () => privateAPI.get(url.GET_TOOLS);

//DASHBOARD DATA
export const postGetDashboardData = (params = {}) => privateAPI.get(url.POST_GET_DASHBOARD_DATA, { params });

//ADMIN CALLS
export const postGetAllOrders = (data) => privateAPI.post(url.POST_GET_ALL_ORDERS, data);
export const postGetAllUsers = (data) => privateAPI.post(url.POST_GET_ALL_USERS, data);
export const postGetUserShadowData = (data) => privateAPI.post(url.POST_GET_USER_SHADOW_DATA, data);
export const postTestPostgresConnection = (data) => privateAPI.post(url.POST_TEST_POSTGRES_CONNECTION, data);
export const postRunPostgresQuery = (data) => privateAPI.post(url.POST_RUN_POSTGRES_QUERY, data);
export const postSyncPostgresIndeksy = (data) => privateAPI.post(url.POST_SYNC_POSTGRES_INDEKSY, data);
export const postSyncPostgresTlumaczenia = (data) => privateAPI.post(url.POST_SYNC_POSTGRES_TLUMACZENIA, data);
export const postSyncPostgresKlasyfikacjeTowarow = (data) => privateAPI.post(url.POST_SYNC_POSTGRES_KLASYFIKACJE_TOWAROW, data);
export const postSyncPostgresCechyDostaw = (data) => privateAPI.post(url.POST_SYNC_POSTGRES_CECHY_DOSTAW, data);
export const postSyncPostgresWartosciZalezne = (data) => privateAPI.post(url.POST_SYNC_POSTGRES_WARTOSCI_ZALEZNE, data);
export const postSyncPostgresCenniki = (data) => privateAPI.post(url.POST_SYNC_POSTGRES_CENNIKI, data);


//NEW SHADOW API

export const postBlindData = (data) => privateAPI.post(url.GET_BLIND_DATA, data).then(r => r.data);

/////////////////////////////////////////////////TODO

//ADMIN CALLS

// export const updateUser = (data) => privateAPI.post(url.UPDATE_USER, data);
// export const deleteUser = (data) => privateAPI.post(url.DELETE_USER, data);
// export const addUser = (data) => privateAPI.post(url.ADD_USER, data);


